import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { authTokens } from '../../redux/Selectors/selectors'
import { makeApiRequest } from '../common/API_request'
import { getTransactionDetails } from '../../redux/Slices/datasetSlice'

function PaymentDetails() {

    const navigate = useNavigate()
    const token = useSelector(authTokens)
    const [correctCard, setCorrectCard] = useState(false)
    const [cardError, setCardError] = useState("")
    const [processing, setProcessing] = useState(false)
    const [paymentError, setPaymentError] = useState("")

    const stripe = useStripe()
    const elements = useElements()

    const {clientSecretKey, price, dataset_access_id} = useSelector(getTransactionDetails)

    async function AuthorizeDataset(transaction_key){
            const url = `${process.env.REACT_APP_SERVER_URL}/api/marketplace/purchase-dataset/`
            const headers = {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token?.accessToken}`
            }
            const body = {
            transaction_key,
            price
            }
            const response = await makeApiRequest(url,"POST",headers,body)
            return response
    }

    const handleChange = (event) => {
        setCorrectCard(event.complete)
        setCardError(event.error)
    }

    const handlePayment = async (e) => {
        e.preventDefault()
        setProcessing(true)

        if(!stripe || !elements || !clientSecretKey){
            setProcessing(false)
            return
        }

        const payload = await stripe.confirmCardPayment(clientSecretKey, {
            payment_method: {
                card : elements.getElement(CardElement)
            }
        })

        // console.log("payload", payload)
        if (payload.error) {
            setPaymentError(`Payment failed: ${payload.error.message}`);
            // FUTURE IMPLEMENTATION
            // Navigate to payment error page, pass the error as prop
            setProcessing(false)
            navigate("/profile/dataset/payments/success")
            return
        }

        const status = await payload?.paymentIntent?.status

        if(status === "succeeded"){
            const KEY = `${payload?.paymentIntent?.client_secret}vanak${dataset_access_id}`
            const response = await AuthorizeDataset(KEY)
            console.log("response", response)
            setProcessing(false)
            navigate("/profile/dataset/payments/success")
            // FUTURE IMPLEMENTATION
            // Navigate to payment success page
        }
    }


  return (
    <div className=''>
        <form  onSubmit={handlePayment} className='border-white rounded-md'>
        <div className='w-full md:w-2/4 py-3 m-4'>
        <p className='my-2'>Enter card details below</p>
        <CardElement
        className='bg-white text-black p-3 rounded-md'
        onChange={handleChange} />

        {cardError && <p className='text-red-600 my-2'>{cardError?.message}</p>}

        <div className='flex justify-end my-4'>
            <button
            disabled={!correctCard || processing}
            className={`${!correctCard ? "bg-enhancedTeal opacity-65" : "bg-customBlue"}
             text-white font-semibold px-4 py-2.5 rounded-md`}>
             {processing ?
            <div
            className="animate-spin rounded-full h-6 w-6 py-2
            border-t-4 border-white"
            />
            :
            `Pay $${price}`
            }

             </button>
        </div>

        {paymentError &&<p className='text-red-600 my-2'>{paymentError}</p>}
        </div>


        </form>
    </div>
  )
}

export default PaymentDetails
